// Central configuration for Funding Sathi
// Update these values in one place to reflect across the entire site

export const CONFIG = {
  // Contact Information
  PHONE: '+91 22 4815 2124',
  PHONE_2: '+91 91104 51232',
  PHONE_RAW: '+912248152124', // For tel: links
  EMAIL: 'info@fundingsathi.in',
  EMAIL_SUPPORT: 'support@fundingsathi.in',
  WHATSAPP: '+919110451232', // WhatsApp number (updated to new mobile)
  
  // Office Address
  ADDRESS: {
    LINE_1: 'GA-14, Lake City Mall',
    LINE_2: 'Near Goenka International School',
    LINE_3: 'Kapurbawadi, Thane West 400607',
    STATE: 'Maharashtra, India'
  },
  
  // Company Info
  COMPANY_NAME: 'Funding Sathi',
  TAGLINE: 'Structured, scalable capital into verified trade ecosystems — without adding balance-sheet risk',
  
  // Social Links
  LINKEDIN: 'https://www.linkedin.com/search/results/all/?keywords=Funding%20Sathi&origin=RICH_QUERY_SUGGESTION&heroEntityKey=urn%3Ali%3Aorganization%3A102510593&position=0',
  INSTAGRAM: 'https://www.instagram.com/fundingsathi?igsh=dHU0a3JxcDB3ZnFq',
  YOUTUBE: 'https://www.youtube.com/',
  
  // Analytics
  GOOGLE_ANALYTICS_ID: 'G-XXXXXXXXXX', // Replace with actual GA ID
  
  // SEO
  SITE_URL: 'https://www.fundingsathi.com',
  DEFAULT_DESCRIPTION: 'Leading financial services provider in India offering Vendor Finance, Dealer Finance, Working Capital, and International Trade solutions.',
  // API base URL (set REACT_APP_API_BASE in env for production, e.g. https://www.fundingsathi.com)
  API_BASE:
    process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.trim() !== ''
      ? process.env.REACT_APP_API_BASE
      : '/server/php-api',
};

export default CONFIG;
